/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const TransactionStatusR = t.interface({});

// optional attributes
const TransactionStatusO = t.partial({
  acsUrl: t.string,

  authorizationCode: t.string,

  expired: t.boolean,

  finalStatus: t.boolean,

  idPayment: t.string,

  idStatus: t.Integer,

  idTransaction: t.Integer,

  paymentOrigin: t.string,

  result: t.string,

  statusMessage: t.string
});

export const TransactionStatus = t.intersection(
  [TransactionStatusR, TransactionStatusO],
  "TransactionStatus"
);

export type TransactionStatus = t.TypeOf<typeof TransactionStatus>;
